import React, {useCallback} from "react";
import {
    RoleIdEnum,
    useCreateCustomerMutation,
    useGetUserListQuery,
} from "../../generated/graphql";
import NotificationPopup from "../../common/NotificationPopup";
import DefaultQueryHandler from "../../common/DefaultQueryHandler";
import CreateView from "../custom/CreateView";
import {InputType} from "../../common/FormRenderer";
import {CustomerTypeList, InvoiceMethodList} from "../../common/Constant";
import {HasRole, saveFile, selectMapFn} from "../../common/Util";
import {Button} from "@material-ui/core";
import ConfirmButton from "../../components/ConfirmButton";

export default () => {
    const { loading, data, error } = useGetUserListQuery({ fetchPolicy: "cache-and-network" });
    const [createCustomer] = useCreateCustomerMutation();
    const onSubmit = useCallback(
        async (customer, { resetForm }, setOpen) => {
            try {
                const newCustomer = await createCustomer({
                    variables: { customer },
                    refetchQueries: ["getCustomerList","getCustomer"],
                });
                NotificationPopup.success(`建立完成`);
                resetForm();
                return newCustomer.data?.createCustomer;
            } catch (e) {
                NotificationPopup.error(`建立客戶發生問題: ${e.message}`);
                console.error(e);
            } finally {
                setOpen(false);
            }
        },
        [createCustomer]
    );
    return (
        <DefaultQueryHandler
            loading={loading}
            error={error}>

            <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.Ae, RoleIdEnum.Pm, RoleIdEnum.Secretary]}>
            <CreateView
                title={"新增客戶"}
                columns={[
                    { name: "name", label: "客戶名稱" },
                    {
                        name: "type",
                        label: "客戶類型",
                        type: InputType.select,
                        options: CustomerTypeList,
                    },
                    { name: "phone", label: "電話" },
                    { name: "fax", label: "傳真" },
                    { name: "address", label: "地址" },
                    {
                        name: "assigneeId",
                        label: "負責人",
                        type: InputType.select,
                        options: data?.users.map(selectMapFn),
                    },
                    { name: "billingAddress", label: "帳單地址" },
                    { name: "taxId", label: "統一編號", required: true },
                    {
                        name: "invoiceMethod",
                        label: "發票開立方法",
                        type: InputType.select,
                        options: InvoiceMethodList,
                    },
                    {
                        name: "defaultDiscountPercentage",
                        label: "現折%數",
                        type: InputType.number,
                    },
                ]}
                onSubmit={onSubmit}
                queryEntity={"customer"}
            />
            </HasRole>
            <HasRole roles={[RoleIdEnum.Finance, RoleIdEnum.Admin, RoleIdEnum.Secretary, RoleIdEnum.AeManager, RoleIdEnum.PmManager, RoleIdEnum.Gm]}>
                &nbsp;&nbsp;
                <Button
                    variant={"contained"}
                    color={"primary"}
                    onClick={()=>saveFile('/reports/customer', '客戶資料表.xlsx')}
                >下載客戶資料</Button>
            </HasRole>
            <HasRole roles={[RoleIdEnum.Finance, RoleIdEnum.Admin, RoleIdEnum.Secretary, RoleIdEnum.AeManager, RoleIdEnum.PmManager, RoleIdEnum.Gm]}>
                &nbsp;&nbsp;
                <Button
                    variant={"contained"}
                    color={"primary"}
                    onClick={()=>saveFile('/customer/fetchLevel', '客戶分級表.xlsx')}
                >下載客戶分級表</Button>
            </HasRole>
            <HasRole roles={[RoleIdEnum.Finance, RoleIdEnum.Admin]}>
                &nbsp;&nbsp;
                <ConfirmButton
                    onConfirm={async () =>
                    {
                        await fetch(`${process.env.REACT_APP_BACKEND_URI}/customer/checkInvoicesExpired`);
                    }}
                >檢查逾期發票</ConfirmButton>
            </HasRole>
        </DefaultQueryHandler>
    );
};
